// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2oEsz","header":"styles_header__2uWYW","status":"styles_status__19o6l","title":"styles_title__zDYBb","actions":"styles_actions__17e2Y"};